import { useInlineNotifications } from '../../../../../../../hooks'
import {
  formValidationSchemaNoChanged,
  useCloseConfirm,
} from '../../../../../../Form'
import { FormikForm } from '../../../../../../Formik'
import { WidgetFormContainer } from '../../../../../../Widget'
import { useListingProfileContext } from '../../../RentalPortalListingProfile.hooks'
import { useListingProfileBlockSave } from '../../RentalPortalListingProfileExpose.hooks'
import { LISTING_PROFILE_DESCRIPTION_DISCARD_CONFIRMATION_PROPS } from '../RentalPortalListingProfileDescriptionWidget.constants'
import {
  getListingDescriptionInitialValues,
  getListingDescriptionPatchPayload,
} from '../RentalPortalListingProfileDescriptionWidget.utils'

import { RentalPortalListingProfileDescriptionWidgetFormFields } from './RentalPortalListingProfileDescriptionWidgetFormFields'

function RentalPortalListingProfileDescriptionWidgetForm({
  onClose,
  onSuccess,
}) {
  const { listingData } = useListingProfileContext()

  const { handleClose, isCloseConfirm, setCloseConfirm } = useCloseConfirm({
    onClose,
  })

  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications()

  const { handleSaveBlock } = useListingProfileBlockSave({
    onClose,
    onRemoveNotification: handleRemoveNotification,
    onSetNotification: handleAddNotification,
  })

  const initialValues = getListingDescriptionInitialValues(listingData)

  function handleSubmit(values, formikHelpers) {
    handleSaveBlock({
      formikHelpers,
      payload: getListingDescriptionPatchPayload(values),
      onSuccess,
    })
  }

  return (
    <FormikForm
      Container={WidgetFormContainer}
      containerProps={{
        confirmationProps:
          LISTING_PROFILE_DESCRIPTION_DISCARD_CONFIRMATION_PROPS,
        isCloseConfirm,
        setCloseConfirm,
        onClose,
      }}
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={formValidationSchemaNoChanged({ initialValues })}
      onSubmit={handleSubmit}
    >
      <RentalPortalListingProfileDescriptionWidgetFormFields
        isCloseConfirm={isCloseConfirm}
        notifications={notifications}
        onCancel={handleClose}
        onRemoveNotification={handleRemoveNotification}
        onSetNotification={handleAddNotification}
      />
    </FormikForm>
  )
}

export default RentalPortalListingProfileDescriptionWidgetForm
